import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export const MapControls = ({ mapType, onMapTypeChange }) => {
  return (
    <div className="absolute bottom-3 left-3 z-10">
      <Select value={mapType} onValueChange={onMapTypeChange}>
        <SelectTrigger size="toolbar" className="w-[140px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="roadmap">Map</SelectItem>
          <SelectItem value="satellite">Satellite</SelectItem>
          <SelectItem value="hybrid">Hybrid</SelectItem>
          <SelectItem value="terrain">Terrain</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
